import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { PAYMENT_GATEWAYS, PROVIDER_TYPES } from '../../../utils/constants/constants';
import { ApiService } from '../../../utils/services/api.service';
import { NotificationsService } from 'angular2-notifications';
import { AppService } from '../../../utils/services/app.service';

@Component({
  selector: 'app-cross-parameters',
  templateUrl: './cross-parameters.component.html',
  styleUrls: ['./cross-parameters.component.css']
})

export class CrossParametersComponent implements OnInit {

  public readonly PROVIDER_TYPES = PROVIDER_TYPES;
  public agencyCrossID;
  public agencyID;
  /////////////////////////////
  public crossParameterForm: FormGroup;
  public isPaymentGateWayVisible = false;
  public paymentGateways = PAYMENT_GATEWAYS;
  public crossParameters: Array<any> = [];
  public paymentTypeOnAccount;
  public paymentTypeCreditCard;
  public paymentGateWay;
  public CreditCardFor3D;
  public organizationID;
  public oldFlightProviders = [];
  public oldHotelProviders = [];
  public oldPackageProviders = [];
  public oldRentingProviders = [];
  public currentProviders = [];
  public oldRequestProviders=[];
  public oldChannelManagerProviders = [];
  public fproviders = [];
  public hproviders = [];
  public pproviders = [];
  public rproviders = [];
  public showUseCompanyPrice;
  public ShowUseCompanyPriceExtraHotel;
  public showUseCompanyPriceModel = false;
  public ShowUseCompanyPriceExtraHotelModel = false;
  public showProvidersLoading = false;
  public showOperationLoading = false;
  public requestProviders=['bizitransfer','bizicar','bizimeeting','biziinsurance']
  public cmproviders = [];
  public acproviders = [];
  public oldAutocompleteProviders = [];

  constructor(private apiService: ApiService,
    private activatedRoute: ActivatedRoute,
    private appService: AppService,
    private notificationsService: NotificationsService,
    private router: Router) {

  }

  ngOnInit() {

    this.organizationID = this.activatedRoute.snapshot.parent.params.id;
    this.agencyID = this.activatedRoute.snapshot.params.agencyID;
    this.agencyCrossID = this.activatedRoute.snapshot.params.crossID;

    this.crossParameterForm = new FormGroup({
      'paymentTypeOnAccount': new FormControl(false, Validators.required),
      'paymentTypeCreditCard': new FormControl(false, Validators.required),
      'paymentGateWay': new FormControl(this.paymentGateways[0]),
      'CreditCardFor3D': new FormControl({ value: false, disable: true}),
      'flightProvider': new FormControl(null),
      'hotelProvider': new FormControl(null),
      'rentingProvider': new FormControl(null),
      'packageProvider': new FormControl(null),
      'requestProvider':new FormControl(null),
      'showUseCompanyPrice': new FormControl(false),
      'ShowUseCompanyPriceExtraHotel': new FormControl(false),
      'CurretProviders': new FormControl(null),
      'channelManagerProvider': new FormControl(null),
      'autocompleteProvider': new FormControl(null)
    });

    this.crossParameterForm.controls.paymentTypeCreditCard.valueChanges.subscribe(
      (value) => {
        this.isPaymentGateWayVisible = value;
        if (value) {
          this.crossParameterForm.controls.paymentGateWay.setValidators(Validators.required);
          this.crossParameterForm.controls.CreditCardFor3D.enable();
        } else {
          this.crossParameterForm.controls.paymentGateWay.setValidators(Validators.nullValidator);
          this.crossParameterForm.controls.CreditCardFor3D.disable();
        }
      }
    );
    this.fetchAgencyProviders();
    this.activatedRoute.data.subscribe((data) => {
      this.paymentTypeOnAccount = null;
      this.paymentTypeCreditCard = null;
      this.paymentGateWay = null;
      this.oldFlightProviders = [];
      this.oldHotelProviders = [];
      this.oldRentingProviders = [];
      this.showUseCompanyPrice = null;
      this.ShowUseCompanyPriceExtraHotel = null;
      this.currentProviders = [];
      this.oldChannelManagerProviders = [];

      data.crossParameters.forEach((crossParam) => {
        if (crossParam.key === 'PaymentType') {
          if (crossParam.value === 'OnAccount') {
            this.paymentTypeOnAccount = crossParam;
          } else if (crossParam.value === 'CreditCard') {
            this.paymentTypeCreditCard = crossParam;
          }
          else if (crossParam.value === 'CreditCardFor3D'){

            this.CreditCardFor3D = crossParam;
            this.crossParameterForm.controls.CreditCardFor3D.patchValue(!!this.CreditCardFor3D);

          }
        } else if (crossParam.key === 'DefaultPaymentGateway') {
          this.paymentGateWay = crossParam;
        } else if (crossParam.key === 'Provider') {
          this.currentProviders.push(crossParam);
          if (crossParam.context === "Flight") {
            this.oldFlightProviders.push(crossParam);
            this.crossParameterForm.controls.flightProvider.patchValue(this.oldFlightProviders ? this.oldFlightProviders[0].value : null);//NOTE: birden fazla provideri olursa sadece ilkini alir
          } else if (crossParam.context === "Hotel") {
            this.oldHotelProviders.push(crossParam);
            this.crossParameterForm.controls.hotelProvider.patchValue(this.oldHotelProviders ? this.oldHotelProviders[0].value : null);
          }
          else if (crossParam.context === "Package") {
            this.oldPackageProviders.push(crossParam);
            this.crossParameterForm.controls.packageProvider.patchValue(this.oldPackageProviders ? this.oldPackageProviders[0].value : null);
          }
          else if (crossParam.context === "Renting") {
            this.oldRentingProviders.push(crossParam);
            this.crossParameterForm.controls.rentingProvider.patchValue(this.oldRentingProviders ? this.oldRentingProviders[0].value : null);
          }
          else if (crossParam.context === "ChannelManager") {
            this.oldChannelManagerProviders.push(crossParam);
            this.crossParameterForm.controls.channelManagerProvider.patchValue(this.oldChannelManagerProviders ? this.oldChannelManagerProviders[0].value : null);
          }
          else if (crossParam.context === "AutoComplete") {
            this.oldAutocompleteProviders.push(crossParam);
            this.crossParameterForm.controls.autocompleteProdiver.patchValue(this.oldAutocompleteProviders ? this.oldAutocompleteProviders[0].value : null);
          }
        } else if (crossParam.key === 'ShowUseCompanyPrice') {
          this.currentProviders.push(crossParam);
          this.showUseCompanyPrice = crossParam;
        }
        else if (crossParam.key === 'ShowUseCompanyPriceExtraHotel') {
          this.ShowUseCompanyPriceExtraHotel = crossParam;
          this.currentProviders.push(crossParam);

        }
      });
      this.showUseCompanyPriceModel = this.showUseCompanyPrice ? (this.showUseCompanyPrice.value != 0 && this.showUseCompanyPrice.value != 'false') : false; //bazen string olarak sıfır veya false geliyor db den
      this.ShowUseCompanyPriceExtraHotelModel = this.ShowUseCompanyPriceExtraHotel ? (this.ShowUseCompanyPriceExtraHotel.value != 0 && this.ShowUseCompanyPriceExtraHotel.value != 'false') : false; //bazen string olarak sıfır veya false geliyor db den
      this.crossParameterForm.controls.paymentTypeOnAccount.patchValue(!!this.paymentTypeOnAccount);
      this.crossParameterForm.controls.paymentTypeCreditCard.patchValue(!!this.paymentTypeCreditCard);
      this.crossParameterForm.controls.paymentGateWay.patchValue(this.paymentGateWay ? this.paymentGateWay.value : null);
      this.crossParameterForm.controls.CreditCardFor3D.patchValue(!!this.CreditCardFor3D);
      this.crossParameterForm.controls.showUseCompanyPrice.patchValue(false);
      this.crossParameterForm.controls.ShowUseCompanyPriceExtraHotel.patchValue(false);
      //this.crossParameterForm.controls.CurretProviders.patchValue(this.CurretProviders ? this.CurretProviders : null);

    });


  }

  updateShowUseCompanyPrice(event) {
    if (this.showUseCompanyPrice && this.showUseCompanyPrice.id) {
        this.showUseCompanyPrice.value = event;
        this.apiService.updateCrossParameter(this.organizationID, this.agencyCrossID, this.showUseCompanyPrice.id, this.showUseCompanyPrice).subscribe(res => {
          this.notificationsService.success('Success', 'Parameter is updated successfully!');
          this.crossParameterForm.controls.showUseCompanyPrice.patchValue(event);
        }, err => {
          this.notificationsService.error('Error', 'Operation failed!');
        })
    } else {
      if (event) {
        this.apiService.postCrossParameter(this.organizationID, this.agencyCrossID, {
          context: 'Hotel',
          key: 'ShowUseCompanyPrice',
          value: true
        }).subscribe(res => {
          this.notificationsService.success('Success', 'Parameter is updated successfully!');
          this.showUseCompanyPrice = res.data;
          this.crossParameterForm.controls.showUseCompanyPrice.patchValue(true);
        }, err => {
          this.notificationsService.error('Error', 'Operation failed!');

        });
      }

    }
  }

  updateShowUseCompanyPriceExtraHotel(event) {
    if (this.ShowUseCompanyPriceExtraHotel && this.ShowUseCompanyPriceExtraHotel.id) {
        this.ShowUseCompanyPriceExtraHotel.value = event;
        this.apiService.updateCrossParameter(this.organizationID, this.agencyCrossID, this.ShowUseCompanyPriceExtraHotel.id, this.ShowUseCompanyPriceExtraHotel).subscribe(res => {
          this.notificationsService.success('Success', 'Parameter is updated successfully!');
          this.crossParameterForm.controls.ShowUseCompanyPriceExtraHotel.patchValue(event);
        }, err => {
          this.notificationsService.error('Error', 'Operation failed!');
        })
    } else {
      if (event) {
        this.apiService.postCrossParameter(this.organizationID, this.agencyCrossID, {
          context: 'Hotel',
          key: 'ShowUseCompanyPriceExtraHotel',
          value: true
        }).subscribe(res => {
          this.notificationsService.success('Success', 'Parameter is updated successfully!');
          this.ShowUseCompanyPriceExtraHotel = res.data;
          this.crossParameterForm.controls.ShowUseCompanyPriceExtraHotel.patchValue(true);
        }, err => {
          this.notificationsService.error('Error', 'Operation failed!');

        });
      }

    }
  }

  fetchAgencyProviders() {
    let agencyID = this.activatedRoute.snapshot.params.agencyID;
    this.showProvidersLoading = true;
    this.apiService.getOrganizationProviders(agencyID, `type_In=${PROVIDER_TYPES.join()}`).subscribe(res => {
      res.data.forEach(element => {
        if (element.type == 'FlightProvider') {
          this.fproviders.push(element.context);
        } else if (element.type == 'HotelProvider') {
          this.hproviders.push(element.context);
        } else if (element.type == 'PackageProvider'){
          this.pproviders.push(element.context);
        } else if (element.type == 'ChannelManagerProvider') {
          this.cmproviders.push(element.context);
        } else if (element.type == 'AutocompleteProvider') {
          this.acproviders.push(element.context);
        } else if (element.type == 'RentingProvider') {
          this.rproviders.push(element.context);
        }
      });
      this.showProvidersLoading = false;
    }, err => {
      this.showProvidersLoading = false;
    })
  }

  savePaymentTypes() {
    if (this.crossParameterForm.controls.paymentTypeOnAccount.valid && this.crossParameterForm.controls.paymentTypeCreditCard.valid && this.crossParameterForm.controls.paymentGateWay.valid) {
      let requests: Array<Observable<any>> = [];

      if (this.paymentTypeOnAccount) {
        if (!this.crossParameterForm.controls.paymentTypeOnAccount.value) {
          requests.push(
            this.apiService.deleteCrossParameter(this.agencyID, this.agencyCrossID, this.paymentTypeOnAccount.id));
        }
      } else {
        if (this.crossParameterForm.controls.paymentTypeOnAccount.value) {
          requests.push(this.apiService.postCrossParameter(this.agencyID, this.agencyCrossID, {
            context: 'Travel',
            key: 'PaymentType',
            value: 'OnAccount'
          }));
        }
      }
      /////////////////////////////////////////////////////
      if (this.paymentTypeCreditCard) {

        if (this.crossParameterForm.controls.paymentTypeCreditCard.value) {
          requests.push(this.apiService.updateCrossParameter(this.agencyID, this.agencyCrossID, this.paymentGateWay.id, {
            value: this.crossParameterForm.controls.paymentGateWay.value
          }));
        } else {
          requests.push(
            this.apiService.deleteCrossParameter(this.agencyID, this.agencyCrossID, this.paymentTypeCreditCard.id)
          );
          requests.push(
            this.apiService.deleteCrossParameter(this.agencyID, this.agencyCrossID, this.paymentGateWay.id)
          );
        }
      } else {
        if (this.crossParameterForm.controls.paymentTypeCreditCard.value) {
          requests.push(this.apiService.postCrossParameter(this.agencyID, this.agencyCrossID, {
            context: 'Travel',
            key: 'PaymentType',
            value: 'CreditCard'
          }));
          requests.push(this.apiService.postCrossParameter(this.agencyID, this.agencyCrossID, {
            context: 'Travel',
            key: 'DefaultPaymentGateway',
            value: this.crossParameterForm.controls.paymentGateWay.value
          }));

        }
      }

      if(this.CreditCardFor3D){

        if (!this.crossParameterForm.controls.CreditCardFor3D.value) {
          requests.push(
            this.apiService.deleteCrossParameter(this.agencyID, this.agencyCrossID, this.CreditCardFor3D.id)
          );
        }
      }else {
        if (this.crossParameterForm.controls.CreditCardFor3D.value) {
          requests.push(this.apiService.postCrossParameter(this.agencyID, this.agencyCrossID, {
            context: 'Travel',
            key: 'PaymentType',
            value: 'CreditCardFor3D'
          }));
        }
      }
      Observable.forkJoin(requests).subscribe(
        response => {
          this.notificationsService.success('Success', 'Cross parameter is updated');
          this.router.navigate(['./'], { relativeTo: this.activatedRoute });

        }, error => {
          this.notificationsService.error('Error', 'Error occured');
          this.router.navigate(['./'], { relativeTo: this.activatedRoute });
        }
      );
    }
  }



  addHotelProvider() {
    //Hotel
    if (this.crossParameterForm.controls.hotelProvider.valid) {
      let requests = [];
      const selectedHotelProviderValue = this.crossParameterForm.controls.hotelProvider.value;
      if (selectedHotelProviderValue && this.hproviders.includes(selectedHotelProviderValue)) {//otel secildiyse
        var alreadyExist = false;
        this.oldHotelProviders.forEach(oldProvider => {
          if (oldProvider.value === selectedHotelProviderValue) {
            alreadyExist = true;//eski ucuslardan bir tanesi bile simdikiyle ayniysa
          }
        })
        if (!alreadyExist) {//secilen otel benzersiz ise
          //requests.push(this.apiService.deleteCrossParameter(this.agencyID, this.agencyCrossID, this.oldFlightProvider.id)); //eskiden silme kodu vardi, neden siliyoruz?
          requests.push(this.apiService.postCrossParameter(this.agencyID, this.agencyCrossID, {
            context: 'Hotel',
            key: 'Provider',
            value: selectedHotelProviderValue
          }));
          if (selectedHotelProviderValue === 'bizihotel') {//secilen oten bizihotel ise showcompanypricei da gonder
            requests.push(this.apiService.postCrossParameter(this.agencyID, this.agencyCrossID, {
              context: 'Hotel',
              key: 'ShowUseCompanyPrice',
              value: (this.crossParameterForm.controls.showUseCompanyPrice.value)
            }));
          }
          if (selectedHotelProviderValue === 'extrahotel') {//secilen oten extrahotel ise showcompanypricei da gonder
            requests.push(this.apiService.postCrossParameter(this.agencyID, this.agencyCrossID, {
              context: 'Hotel',
              key: 'ShowUseCompanyPriceExtraHotel',
              value: (this.crossParameterForm.controls.ShowUseCompanyPriceExtraHotel.value)
            }));
          }
        } else {
          this.notificationsService.warn('Warning', 'This provider is already added!');
        }
      }
      //otel secilmediyse ve otel secilse dahi eskiden olanlardan biriyle ayniysa hicbir sey yapma
      Observable.forkJoin(requests).subscribe(
        response => {
          this.notificationsService.success('Success', 'Cross parameter is updated');
          this.router.navigate(['./'], { relativeTo: this.activatedRoute });
        }, error => {
          this.notificationsService.error('Error', error.error.message);
          this.router.navigate(['./'], { relativeTo: this.activatedRoute });
        }
      );
    }

  }

  addFlightProvider() {
    if (this.crossParameterForm.controls.flightProvider.valid) {
      //Flight
      const selectedFlightProviderValue = this.crossParameterForm.controls.flightProvider.value;
      if (selectedFlightProviderValue && this.fproviders.includes(selectedFlightProviderValue)) {//ucus secildiyse
        var alreadyExist = false;
        this.oldFlightProviders.forEach(oldProvider => {
          if (oldProvider.value === selectedFlightProviderValue) {
            alreadyExist = true;//eski ucuslardan bir tanesi bile simdikiyle ayniysa
          }
        })
        if (!alreadyExist) {//secilen ucus benzersiz ise
          //requests.push(this.apiService.deleteCrossParameter(this.agencyID, this.agencyCrossID, this.oldFlightProvider.id)); //eskiden silme kodu vardi, neden siliyoruz?
          let postData = {
            context: 'Flight',
            key: 'Provider',
            value: selectedFlightProviderValue
          }
          this.apiService.postCrossParameter(this.agencyID, this.agencyCrossID, postData).subscribe(
            response => {
              this.notificationsService.success('Success', 'Cross parameter is saved');

              this.router.navigate(['./'], { queryParams: { refresh: true }, relativeTo: this.activatedRoute });
            }, error => {
              this.notificationsService.error('Error', error.error.message);
              this.router.navigate(['./'], { relativeTo: this.activatedRoute });
            }
          )
        } else {
          this.notificationsService.warn('Warning', 'This provider is already added!');
        }
        //ucus secilmediyse ve ucus secilse dahi eskiden olanlardan biriyle ayniysa hicbir sey yapma
      }
    }
  }

  addPackageProvider() {
    if (this.crossParameterForm.controls.packageProvider.valid) {
      //Flight
      const selectedPackageProviderValue = this.crossParameterForm.controls.packageProvider.value;
      if (selectedPackageProviderValue && this.pproviders.includes(selectedPackageProviderValue)) {//ucus secildiyse
        var alreadyExist = false;
        this.oldPackageProviders.forEach(oldProvider => {
          if (oldProvider.value === selectedPackageProviderValue) {
            alreadyExist = true;//eski ucuslardan bir tanesi bile simdikiyle ayniysa
          }
        })
        if (!alreadyExist) {//secilen ucus benzersiz ise
          let postData = {
            context: 'Package',
            key: 'Provider',
            value: selectedPackageProviderValue
          }
          this.apiService.postCrossParameter(this.agencyID, this.agencyCrossID, postData).subscribe(
            response => {
              this.notificationsService.success('Success', 'Cross parameter is saved');
              this.router.navigate(['./'], { queryParams: { refresh: true }, relativeTo: this.activatedRoute });
            }, error => {
              this.notificationsService.error('Error', error.error.message);
              this.router.navigate(['./'], { relativeTo: this.activatedRoute });
            }
          )
        } else {
          this.notificationsService.warn('Warning', 'This provider is already added!');
        }
        //ucus secilmediyse ve ucus secilse dahi eskiden olanlardan biriyle ayniysa hicbir sey yapma
      }
    }
  }

  addRentingProvider() {
    if (this.crossParameterForm.controls.rentingProvider.valid) {
      const selectedRentingProviderValue = this.crossParameterForm.controls.rentingProvider.value;
      if (selectedRentingProviderValue && this.rproviders.includes(selectedRentingProviderValue)) {
        var alreadyExist = false;
        this.oldRentingProviders.forEach(oldProvider => {
          if (oldProvider.value === selectedRentingProviderValue) {
            alreadyExist = true;
          }
        })
        if (!alreadyExist) {
          let postData = {
            context: 'Renting',
            key: 'Provider',
            value: selectedRentingProviderValue
          }
          this.apiService.postCrossParameter(this.agencyID, this.agencyCrossID, postData).subscribe(
            response => {
              this.notificationsService.success('Success', 'Cross parameter is saved');
              this.router.navigate(['./'], { queryParams: { refresh: true }, relativeTo: this.activatedRoute });
            }, error => {
              this.notificationsService.error('Error', error.error.message);
              this.router.navigate(['./'], { relativeTo: this.activatedRoute });
            }
          )
        } else {
          this.notificationsService.warn('Warning', 'This provider is already added!');
        }
      }
    }
  }

  addRequestProvider(){
    if (this.crossParameterForm.controls.packageProvider.valid) {
      //Flight
      const selectedRequestProviderValue = this.crossParameterForm.controls.requestProvider.value;
      if (selectedRequestProviderValue && this.requestProviders.includes(selectedRequestProviderValue)) {//ucus secildiyse
        var alreadyExist = false;
        this.oldRequestProviders.forEach(oldProvider => {
          if (oldProvider.value === selectedRequestProviderValue) {
            alreadyExist = true;//eski ucuslardan bir tanesi bile simdikiyle ayniysa
          }
        })
        if (!alreadyExist) {//secilen ucus benzersiz ise
          let postData = {
            context: 'TravelRequest',
            key: 'Provider',
            value: selectedRequestProviderValue
          }
          this.apiService.postCrossParameter(this.agencyID, this.agencyCrossID, postData).subscribe(
            response => {
              this.notificationsService.success('Success', 'Cross parameter is saved');
              this.router.navigate(['./'], { queryParams: { refresh: true }, relativeTo: this.activatedRoute });
            }, error => {
              this.notificationsService.error('Error', error.error.message);
              this.router.navigate(['./'], { relativeTo: this.activatedRoute });
            }
          )
        } else {
          this.notificationsService.warn('Warning', 'This provider is already added!');
        }
      }
    }
  }

  addChannelManagerProvider() {
    if (this.crossParameterForm.controls.channelManagerProvider.valid) {
      const selectedChannelManagerProviderValue = this.crossParameterForm.controls.channelManagerProvider.value;
      if (selectedChannelManagerProviderValue && this.cmproviders.includes(selectedChannelManagerProviderValue)) {
        let alreadyExist = false;
        this.oldChannelManagerProviders.forEach(oldProvider => {
          if (oldProvider.value === selectedChannelManagerProviderValue) {
            alreadyExist = true;//
          }
        })
        if (!alreadyExist) {
          let postData = {
            context: 'ChannelManager',
            key: 'Provider',
            value: selectedChannelManagerProviderValue
          }
          this.apiService.postCrossParameter(this.agencyID, this.agencyCrossID, postData).subscribe(
            response => {
              this.notificationsService.success('Success', 'Cross parameter is saved');
              this.router.navigate(['./'], { relativeTo: this.activatedRoute });
            }, error => {
              this.notificationsService.error('Error', error.error.message);
              this.router.navigate(['./'], { relativeTo: this.activatedRoute });
            }
          )
        } else {
          this.notificationsService.warn('Warning', 'This provider is already added!');
        }
      }
    }
  }

  addAutocompleteProvider() {
    if (this.crossParameterForm.controls.autocompleteProvider.valid) {
      const selectedAutocompleteProviderValue = this.crossParameterForm.controls.autocompleteProvider.value;
      if (selectedAutocompleteProviderValue && this.acproviders.includes(selectedAutocompleteProviderValue)) {
        let alreadyExist = false;
        this.oldAutocompleteProviders.forEach(oldProvider => {
          if (oldProvider.value === selectedAutocompleteProviderValue) {
            alreadyExist = true;//
          }
        })
        if (!alreadyExist) {
          let postData = {
            context: 'Autocomplete',
            key: 'Provider',
            value: selectedAutocompleteProviderValue
          }
          this.apiService.postCrossParameter(this.agencyID, this.agencyCrossID, postData).subscribe(
            response => {
              this.notificationsService.success('Success', 'Cross parameter is saved');
              this.router.navigate(['./'], { relativeTo: this.activatedRoute });
            }, error => {
              this.notificationsService.error('Error', error.error.message);
              this.router.navigate(['./'], { relativeTo: this.activatedRoute });
            }
          )
        } else {
          this.notificationsService.warn('Warning', 'This provider is already added!');
        }
      }
    }
  }

  deleteProvider(providerItem, providerIndex) {
    let requests = [];
    requests.push(this.apiService.deleteCrossOrganizationParameter(providerItem.id, this.organizationID, this.agencyCrossID));
    if (providerItem.value === 'bizihotel') {
      if (this.showUseCompanyPrice) {
        this.showUseCompanyPriceModel = false;
        if(this.showUseCompanyPrice)
          requests.push(this.apiService.deleteCrossOrganizationParameter(this.showUseCompanyPrice.id, this.organizationID, this.agencyCrossID));
      }
    }
    if (providerItem.value === 'extrahotel') {
      if (this.ShowUseCompanyPriceExtraHotel) {
        this.ShowUseCompanyPriceExtraHotelModel = false;
        if(this.ShowUseCompanyPriceExtraHotel)
          requests.push(this.apiService.deleteCrossOrganizationParameter(this.ShowUseCompanyPriceExtraHotel.id, this.organizationID, this.agencyCrossID));
      }
    }
    Observable.forkJoin(requests).subscribe(res => {
      this.notificationsService.success('Success', 'Delete operation is successful!');
      this.currentProviders.splice(providerIndex, 1);
      if (providerItem.context === 'Flight') {
        let itemIndex = this.oldFlightProviders.findIndex(item => item.id == providerItem.id);
        this.oldFlightProviders.splice(itemIndex, 1);
      }
      if (providerItem.context === 'Hotel') {
        let itemIndex = this.oldHotelProviders.findIndex(item => item.id == providerItem.id);
        this.oldHotelProviders.splice(itemIndex, 1);
        if (providerItem.value == 'bizihotel') {
          let showUseCompanyPriceIndex = this.currentProviders.findIndex(item => item.key == 'ShowUseCompanyPrice');
          if (showUseCompanyPriceIndex > -1)
            this.currentProviders.splice(showUseCompanyPriceIndex, 1);
        }
        if (providerItem.value == 'extrahotel') {
          let ShowUseCompanyPriceExtraHotelIndex = this.currentProviders.findIndex(item => item.key == 'ShowUseCompanyPriceExtraHotel');
          if (ShowUseCompanyPriceExtraHotelIndex > -1)
            this.currentProviders.splice(ShowUseCompanyPriceExtraHotelIndex, 1);
        }
      }
      if (providerItem.context === 'Package') {
        let itemIndex = this.oldPackageProviders.findIndex(item => item.id == providerItem.id);
        this.oldPackageProviders.splice(itemIndex, 1);
      }
      if (providerItem.context === 'Renting') {
        let itemIndex = this.oldRentingProviders.findIndex(item => item.id == providerItem.id);
        this.oldRentingProviders.splice(itemIndex, 1);
      }
      if (providerItem.context === 'ChannelManager') {
        let itemIndex = this.oldChannelManagerProviders.findIndex(item => item.id == providerItem.id);
        this.oldChannelManagerProviders.splice(itemIndex, 1);
      }
      if (providerItem.context === 'Autocomplete') {
        let itemIndex = this.oldAutocompleteProviders.findIndex(item => item.id == providerItem.id);
        this.oldAutocompleteProviders.splice(itemIndex, 1);
      }
    }), err => {
      this.notificationsService.error('Failed', 'Delete operation failed!');
    };
  }
}



// WEBPACK FOOTER //
// C:/Biziclick/bizisystem/src/app/main/frames/cross-parameters/cross-parameters.component.ts